import React from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import NotFound from "../components/not-found";
import Footer from "../components/footer/footer";
import About from "./about/about";
import Accounts from "./accounts/accounts";
import ChangePassword from "./change-password/change-password";
import Dashboard from "./dashboard/dashboard";
import Faq from "./faq/faq";
import ContactUs from "./contact-us/contact-us";
import PrivacyPolicy from "./privacy-policy/privacy-policy";
import Products from "./products/products";
import Terms from "./terms/terms";
import AdminTop from "./ui/admin-top";
import { getCurrentUser } from "../lib/auth_base/localstorage";
import { checkSession, logout } from "../lib/auth_base/auth-service";

const Admin = () => {

  let navigate = useNavigate();
  console.log("CURRENT USER:: ", getCurrentUser());
  React.useEffect(() => {
    checkSession().then(
      (res) => {
        console.log("SESSION CHECK RESULT:: ", res);
        if (!res.status || res.status === 0) {
        //logout();
          //return navigate("/login");
        }
      },
      (error) => {
        console.log(error.message);
        //logout();
        //return navigate("/login");
      }
    );
  }, []);
  return (
    <React.Fragment>
  <AdminTop/>
  
      <div className="py30">
        <div className="page-wrap white">
      <Routes>
        <Route path="/" element={ <Dashboard />}></Route>
        <Route path="" element={<Dashboard/>} ></Route>
        <Route path="/about//*" element={<About/>}></Route>
        <Route path="/accounts//*" element={<Accounts/>}></Route>
        <Route path="/change-password//*" element={<ChangePassword/>}></Route>
        <Route path="/contact-us//*" element={<ContactUs/>}></Route>
        <Route path="/faq//*" element={<Faq/>}></Route>
        <Route path="/privacy-policy//*" element={<PrivacyPolicy/>}></Route>
        <Route path="/products//*" element={<Products/>}></Route>
        <Route path="/terms//*" element={<Terms/>}></Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      </div>
      </div>
     <Footer />
    </React.Fragment>
  );
};

export default Admin;
